export enum EEventType {
  EVENT = 'EVENT',
  LIVE_CLASS = 'LIVE_CLASS'
}

export enum EEventWeekdays {
  MONDAY = 'MONDAY',
  TUESDAY = 'TUESDAY',
  WEDNESDAY = 'WEDNESDAY',
  THURSDAY = 'THURSDAY',
  FRIDAY = 'FRIDAY',
  SATURDAY = 'SATURDAY',
  SUNDAY = 'SUNDAY'
}

export const EVENT_TYPES = [EEventType.EVENT, EEventType.LIVE_CLASS];

export const ALL_WEEKDAYS = Object.values(EEventWeekdays);

export enum EStudentCalendarEventType {
  VIEWED = 'VIEWED',
  NOT_VIEWED = 'NOT_VIEWED',
  TUTORIAL = 'TUTORIAL',
  DEFAULT = 'DEFAULT'
}

export enum ELiveRecordFilter {
  ALL = 'all',
  SEEN = 'seen',
  NOT_SEEN = 'not_seen'
}

export enum ECalendarViewType {
  DAY_GRID_MONTH = 'dayGridMonth',
  TIME_GRID_DAY = 'timeGridDay',
  TIME_GRID_WEEK = 'timeGridWeek',
  LIST_WEEK = 'listWeek'
}
